import { UITable } from '../../components/table/ui-table';
import type { ComponentPlugin } from '../../components/ui-element.type';

/**
 * @class
 * @memberof SharedComponents
 * @classdesc Class for ui-table merge plugin.
 * @alias UITableMerge
 * @implements {ComponentPlugin}
 * @param {HTMLTableElement} target Target instance.
 */
export class UITableMerge implements ComponentPlugin {
    private readonly target: UITable;

    constructor(target: UITable) {
        this.target = target;
    }

    /**
     * @inheritDoc
     */
    render(): void {
        this.target.table.classList.add('-merge');
    }
}

UITable.registerPlugin('merge', UITableMerge);
